import { useEffect, useState } from "react";
import CheckListView from "./CheckListView";
import { Container } from "@mui/material";
import Blocks from "../Blocks";
import ConfirmationPopUp from "../../MessageBox/ConfirmationPopUp";
import checkListInspectionStores from "../../../Stores/CheckListInspectionStores";
import CheckListConstants from "../../../Constants/CheckListInspectionConstant";
import CheckListInspectionAction from "../../../Actions/CheckListInspectionAction";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import { toast } from "react-toastify";
import Header from "./Header";
import InspectionFeedBack from "./InspectionFeedBack";
import { ConstructInspectionObject } from "./ConstructInspectionObject";
import {
  useLanguageActionContext,
  useLanguageContext,
} from "../../../Context/LanguageContext";
import { _functionHelper } from "../HelperFunction/HelperFunction";
import { v4 as uuid } from "uuid";

export default function IndexCheckList({
  equipmentDetails,
  setIsInspectionStart,
  logoutClick,
}) {
  const { language, localization } = useLanguageContext();
  const UpdateLanguage = useLanguageActionContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [checkListTitle, setCheckListTitle] = useState("");
  const [activeChapter, setActiveChapter] = useState(0);
  const [response, SetResponse] = useState(null);
  const [chapterListSetting, setChapterListSetting] = useState(null);
  const [checkList, setChecklist] = useState(null);

  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);
  const [showCancel, setShowCancel] = useState(false);
  const [resetBlock, setResetBlock] = useState(false);
  const [showFeedBackPop, setShowFeedBackPop] = useState(false);
  const [inspectionImage, setInspectionImage] = useState(null);
  const [uniqueClientId, setUniqueClientId] = useState(null);
  const [isEquipmentNio, setIsEquipmentNio] = useState(false);
  const [isCreateTicketActive, setIsCreateTicketActive] = useState(false);

  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "ALERT_CHAPTER_CHANGE":
          closePopUpCallback();
          break;
        case "LEAVE_INSPECTION":
          setCheckListTitle("");
          SetResponse(() => null);
          setActiveChapter(() => 0);
          setInspectionImage(null);
          setIsCreateTicketActive(false);
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      switch (eventType) {
        case "LEAVE_INSPECTION":
          closePopUpCallback();
          break;
        default:
          break;
      }
    }
  };

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };

  const ConfirmationCallback = (data) => {
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(data.message);
    setCallbackData({
      data: "",
    });
    setEventType(data.type);
  };

  useEffect(() => {
    setGlobalSpinner(true);
    CheckListInspectionAction.getAnlageCheckList(equipmentDetails.anlageID);
  }, []);

  useEffect(() => {
    setIsInspectionStart(checkListTitle === "" ? false : true);
  }, [checkListTitle]);

  useEffect(() => {
    if (response) {
      setChapterListSetting({
        totalChapter: response["checklistChapterModels"].length,
        activeChapter: activeChapter + 1,
        nameChapter: response["checklistChapterModels"][activeChapter]["title"],
      });
    } else if (chapterListSetting) {
      setChapterListSetting(null);
    }
  }, [response]);

  /* <>--------------------------------------------------------------------Get CheckList details----------------------------------------------------------<> */
  useEffect(() => {
    function getCheckListDetailsSuccess() {
      var res = checkListInspectionStores.getResult();
      if (res) {
        res["checklistChapterModels"].forEach((chapter) => {
          chapter.checklistBlockModels.forEach((block) => {
            block.pruefFragenItemModels.forEach((question) => {
              if (_functionHelper.isQueType(question.answerType)) {
                question.value = { first: "", second: "" };
                question.errorMessage = { first: "", second: "" };
              } else {
                question.value =
                  question.answerType.toLowerCase() === "yes/no"
                    ? question.defaultAnswer == null
                      ? null
                      : question.defaultAnswer
                        ? "J"
                        : "N"
                    : "";
                question.errorMessage = "";
              }
              // Initialize optional question image field
              question.questionImage = null;
              if (question.shouldTakeEquipmentOutOfOrder) {
                question["withoutTransaltedExpectedRes"] = question.antwort;
                question["expectedResult"] =
                  question.answerType.toLowerCase() === "yes/no"
                    ? question.antwort === "J"
                      ? localization.yes
                      : localization.no
                    : question.antwort.trim();
              }
              question.error = false;
              question.createTicket = false;
            });
            block.blockIsTicket = false;
          });
        });
        if (
          ["onlynio", "bothioandnio"].includes(res["photoNeeded"].toLowerCase())
        ) {
          res["inspectionImage"] = [];
        }
        res["startDate"] = new Date().toISOString();
        setUniqueClientId(uuid());
        SetResponse(res);
      }

      setGlobalSpinner(false);
    }

    function getCheckListDetailsFailure() {
      var res = checkListInspectionStores.getResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    checkListInspectionStores.addChangeListener(
      CheckListConstants.GET_CHECKLIST_DETAILS_SUCCESS,
      getCheckListDetailsSuccess,
    );

    checkListInspectionStores.addChangeListener(
      CheckListConstants.GET_CHECKLIST_DETAILS_FAILURE,
      getCheckListDetailsFailure,
    );

    return () => {
      checkListInspectionStores.removeChangeListener(
        CheckListConstants.GET_CHECKLIST_DETAILS_SUCCESS,
        getCheckListDetailsSuccess,
      );

      checkListInspectionStores.removeChangeListener(
        CheckListConstants.GET_CHECKLIST_DETAILS_FAILURE,
        getCheckListDetailsFailure,
      );
    };
  }, []);

  useEffect(() => {
    function getInspectionSaveSuccess() {
      var res = checkListInspectionStores.getResult();
      if (res) {
        toast.success(localization.inspectionSuccess);
        setInspectionImage(null);
        setCheckListTitle("");
        SetResponse(() => null);
        setActiveChapter(() => 0);
        setIsCreateTicketActive(false);
      }
      setShowFeedBackPop(false);
      setGlobalSpinner(false);
    }

    function getInspectionSaveFailure() {
      var res = checkListInspectionStores.getResult();
      toast.error(res);

      setGlobalSpinner(false);
    }

    checkListInspectionStores.addChangeListener(
      CheckListConstants.SAVE_INSPECTION_SUCCESS,
      getInspectionSaveSuccess,
    );

    checkListInspectionStores.addChangeListener(
      CheckListConstants.SAVE_INSPECTION_FAILURE,
      getInspectionSaveFailure,
    );

    return () => {
      checkListInspectionStores.removeChangeListener(
        CheckListConstants.SAVE_INSPECTION_SUCCESS,
        getInspectionSaveSuccess,
      );

      checkListInspectionStores.removeChangeListener(
        CheckListConstants.SAVE_INSPECTION_FAILURE,
        getInspectionSaveFailure,
      );
    };
  }, []);

  useEffect(() => {
    function getAnlageCheckListSuccess() {
      var res = checkListInspectionStores.getResult();
      if (res) {
        setChecklist(res);
      }
      setGlobalSpinner(false);
    }

    function getAnlageCheckListFailure() {
      var res = checkListInspectionStores.getResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    checkListInspectionStores.addChangeListener(
      CheckListConstants.GET_ANLAGE_CHECKLIST_SUCCESS,
      getAnlageCheckListSuccess,
    );

    checkListInspectionStores.addChangeListener(
      CheckListConstants.GET_ANLAGE_CHECKLIST_FAILURE,
      getAnlageCheckListFailure,
    );

    return () => {
      checkListInspectionStores.removeChangeListener(
        CheckListConstants.GET_ANLAGE_CHECKLIST_SUCCESS,
        getAnlageCheckListSuccess,
      );

      checkListInspectionStores.removeChangeListener(
        CheckListConstants.GET_ANLAGE_CHECKLIST_FAILURE,
        getAnlageCheckListFailure,
      );
    };
  }, []);

  function handleNextChapter(selctedBlock) {
    if (response["checklistChapterModels"][activeChapter]["isMandatory"]) {
      const isRequiredEmpty = _functionHelper.allowNextFromTop(
        response["checklistChapterModels"][activeChapter][
          "checklistBlockModels"
        ],
      );
      if (isRequiredEmpty) {
        if (showCancel) {
          setShowCancel(false);
        }
        ConfirmationCallback({
          message: localization.chapterRequired,
          type: "ALERT_CHAPTER_CHANGE",
        });
      } else {
        setResetBlock(() => true);
        setChapterListSetting((prev) => ({
          ...prev,
          activeChapter: prev.activeChapter + 1,
          nameChapter:
            response["checklistChapterModels"][activeChapter + 1]["title"],
        }));
        setActiveChapter(activeChapter + 1);
      }
    } else {
      const _tempBlock =
        selctedBlock === "allBlock"
          ? response["checklistChapterModels"][activeChapter][
              "checklistBlockModels"
            ]
          : response["checklistChapterModels"][activeChapter][
              "checklistBlockModels"
            ][selctedBlock];
      const _isRequiredContain = _functionHelper.checkBlockListRequired(
        _tempBlock,
        selctedBlock,
      );
      if (_isRequiredContain.isBlockMandtory) {
        if (showCancel) {
          setShowCancel(false);
        }
        ConfirmationCallback({
          message: `${
            localization.checkListblock
          } ${_isRequiredContain.blockList.join(",")} ${
            localization.areMandtory + localization.youCannotSkipTheChapter
          }`,
          type: "ALERT_CHAPTER_CHANGE",
        });
      } else if (_isRequiredContain.isquestionMandtory) {
        if (showCancel) {
          setShowCancel(false);
        }
        ConfirmationCallback({
          message: `${localization.checkListblock} ${_isRequiredContain.index} ${localization.containsMandatoryQuestion}`,
          type: "ALERT_CHAPTER_CHANGE",
        });
      } else {
        setResetBlock(() => true);
        setChapterListSetting((prev) => ({
          ...prev,
          activeChapter: prev.activeChapter + 1,
          nameChapter:
            response["checklistChapterModels"][activeChapter + 1]["title"],
        }));
        setActiveChapter(activeChapter + 1);
      }
    }
  }

  function handlePreviousChapter() {
    setResetBlock(() => true);
    setChapterListSetting((prev) => ({
      ...prev,
      activeChapter: prev.activeChapter - 1,
      nameChapter:
        response["checklistChapterModels"][activeChapter - 1]["title"],
    }));
    setActiveChapter((prev) => activeChapter - 1);
  }

  function handleChangeField(Data, selectdBlockIndex) {
    const _temp = { ...response };
    _temp["checklistChapterModels"][activeChapter]["checklistBlockModels"][
      selectdBlockIndex
    ]["pruefFragenItemModels"] = Data;
    SetResponse(_temp);
  }

  function handleCreateTicketFlag(questionId) {
    let temp = { ...response };
    let createTicketFlag = false;

    temp.checklistChapterModels.map((chapter, chapterIndex) => {
      chapter.checklistBlockModels.map((block, blockIndex) => {
        block.pruefFragenItemModels.map((que, questioIndex) => {
          if (que.id == questionId) {
            que.createTicket = !que.createTicket;
          }
          if (que.createTicket) {
            createTicketFlag = true;
          }
        });
      });
    });

    if (createTicketFlag) {
      setIsCreateTicketActive(true);
    } else {
      setIsCreateTicketActive(false);
    }
    SetResponse(temp);
  }

  useEffect(() => {
    UpdateLanguage(language);
    return () => {};
  }, [language]);

  function handleBack() {
    setShowCancel(true);
    ConfirmationCallback({
      message: localization.alertMessage,
      type: "LEAVE_INSPECTION",
    });
  }

  function handleSaveInspection(
    e,
    ticketTitle,
    ticketDescription,
    ticketCategory,
    ticketPriority,
    _feedBack,
  ) {
    e.preventDefault();

    feedBackCallBack(
      ticketTitle,
      ticketDescription,
      ticketCategory,
      ticketPriority,
      _feedBack,
    );
  }

  function feedBackCallBack(
    ticketTitle,
    ticketDescription,
    ticketCategory,
    ticketPriority,
    _feedBackValue,
  ) {
    const _resoponse = ConstructInspectionObject(
      response["checklistChapterModels"],
      checkListTitle,
      _feedBackValue,
      equipmentDetails,
      response["photoNeeded"],
      inspectionImage,
      uniqueClientId,
      isEquipmentNio,
      response["startDate"],
      ticketTitle,
      ticketDescription,
      ticketCategory,
      ticketPriority,
      language,
    );
    setGlobalSpinner(true);
    CheckListInspectionAction.saveInspection(_resoponse);
  }
  function handleSummaryAction(_type, _value) {
    if ("inspectionImage") {
      const _temp = { ...response };
      _temp["inspectionImage"] = _value;
      setInspectionImage(_value);
      SetResponse(_temp);
    }
  }
  return (
    <>
      <Header
        checkListTitle={checkListTitle}
        handleNextChapter={handleNextChapter}
        handlePreviousChapter={handlePreviousChapter}
        chapterListSetting={chapterListSetting}
        handleBack={handleBack}
        logoutClick={() => logoutClick(false)}
      />
      <Container id="inspectionContainer" className="inspectionCont">
        <div className="InspectionContent mt-5">
          {checkListTitle === "" && (
            <CheckListView
              checkList={checkList}
              setCheckListTitle={setCheckListTitle}
            />
          )}
          {response && (
            <Blocks
              activeChapter={activeChapter}
              totalChapter={response["checklistChapterModels"].length}
              handleChangeField={handleChangeField}
              resetBlock={resetBlock}
              setResetBlock={setResetBlock}
              blocksList={
                response["checklistChapterModels"][activeChapter][
                  "checklistBlockModels"
                ]
              }
              handleSaveInspection={handleSaveInspection}
              handleNextChapter={handleNextChapter}
              chapterList={response}
              inspectionImage={inspectionImage}
              handleSummaryAction={handleSummaryAction}
              equipmentDetails={equipmentDetails}
              setIsEquipmentNio={setIsEquipmentNio}
              isEquipmentNio={isEquipmentNio}
              handleAbort={handleBack}
              handleCreateTicketFlag={handleCreateTicketFlag}
              isCreateTicketActive={isCreateTicketActive}
            />
          )}
        </div>
      </Container>

      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
        isCancelShow={showCancel}
      />
      {showFeedBackPop && (
        <InspectionFeedBack
          equipmentDetails={equipmentDetails}
          feedBackCallBack={feedBackCallBack}
          setShowFeedBackPop={setShowFeedBackPop}
        />
      )}
    </>
  );
}
